import { createDomain, sample } from 'effector'
import { AxiosErrorType, Driver } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { notificationModalOpen } from '~/shared/lib/notificationModal'
import { getDriver } from '../../model'
import { uploadDocumentsModel } from './ui/Form'

const domain = createDomain('entities.driver.uploadDocumentDrawer')

export const openUploadDocumentDrawer = domain.createEvent()
export const closeUploadDocumentDrawer = domain.createEvent()

export const $isUploadDocumentDrawerOpen = domain
  .createStore<boolean>(false)
  .on(openUploadDocumentDrawer, () => true)
  .on(closeUploadDocumentDrawer, () => false)

export const createUpdateRequest =
  domain.createEvent<uploadDocumentsModel.FormValues>()

export const createUpdateRequestFx = domain.createEffect<
  uploadDocumentsModel.FormValues,
  void,
  AxiosErrorType
>({
  async handler(values) {
    await Driver.createUpdateRequest(values)
  },
})

sample({
  clock: createUpdateRequest,
  target: createUpdateRequestFx,
})

sample({
  clock: createUpdateRequestFx.doneData,
  fn() {
    return {
      title: 'Документы отправлены',
      description:
        'Проверка может занять до 30 минут. После прохождения повторных проверок вы сможете арендовать автомобиль',
      variant: 'success' as const,
    }
  },
  target: [notificationModalOpen, closeUploadDocumentDrawer, getDriver],
})

sample({
  clock: createUpdateRequestFx.failData,
  fn(e) {
    return {
      title: 'Ошибка сервиса!',
      description: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: notificationModalOpen,
})
